<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - ROOT大师（手机）
        </div>
        <product-menu now="irootm" />
        <div class="v100 bigimg mt20">
            <img alt="ROOT大师（手机）" src="@/assets/images/romastersu_banner.jpg" />
            <div class="brand">
				<img src="@/assets/images/rootds.jpg" alt="ROOT大师（手机）" height="75" width="121" />
			</div>
            <h1 style="display: block; position: absolute; left: -5999px">ROOT大师（手机）</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="ROOT大师（手机），首创手机一键ROOT" class="fl" src="@/assets/images/Ray1.jpg">
                <dt class="fr">首创手机一键ROOT</dt>
                <dd class="fr">无需电脑、数据线、告别繁琐程序，直接手机端ROOT</dd>
                </dl>
            <dl>
                <img alt="ROOT大师（手机），上万款机型支持" class="fr" src="@/assets/images/Ray2.jpg" />
                <dt class="fl">上万款机型支持</dt>
                <dd class="fl">独家适配三星、HTC、小米上万款机型Root方案</dd>
            </dl>
            <dl>
                <img alt="ROOT大师（手机），超高root成功率" class="fl" src="@/assets/images/Ray3.jpg" />
                <dt class="fr">超高root成功率</dt>
                <dd class="fr">全球较高root成功率，三年root技术经验笑傲业界</dd>
            </dl>
            <dl>
                <img alt="ROOT大师（手机），专业授权管理" class="fr" src="@/assets/images/Ray4.jpg" />
                <dt class="fl">专业授权管理</dt>
                <dd class="fl">专业授权管理应用，助您全面掌控应用权限</dd>
            </dl>
        </div>
    </div>
</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "irootm",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/irootm.vue